/* ============================================================
   GOB — discount guard
   2026-09-03. Two jobs, both proven against the live storefront first.

   FIX 1 — a removed code must stay removed.
     /discount/CODE writes a cookie named discount_code on the storefront
     domain. It is NOT HttpOnly, so this file can delete it. Removing a code
     inside checkout does not clear that cookie, which is how a code the
     shopper thought they had dropped comes back later. Whenever the cart no
     longer carries the code the cookie names, the cookie is deleted.

   FIX 2 — a Club member must never be quietly downgraded.
     The Club 30% is an AUTOMATIC discount and JFN, WELCOME15 and the rest are
     CODE discounts. Every one of them is set to combine with nothing, and when
     a code and an automatic discount both apply Shopify keeps the code. So a
     member holding a 20% code silently pays 10 points more than their
     membership promises, and the Club row disappears from the cart.

     When a member's cart carries a code worth less than 30%, the code is
     removed, the shopper is told plainly what happened, and an undo is offered.

   WHY IT IS SAFE TO ACT AUTOMATICALLY
     The member signal is a customer tag, and that tag write is known to be
     unreliable (see the 26 Aug cart-receipt note). So nothing here is
     irreversible: POST /cart/update.js accepts a code as well as an empty
     string — verified live, apply -> remove -> re-apply all worked — so the
     undo genuinely restores the exact code. A wrongly-tagged shopper loses
     nothing they cannot get back in one click, and the removal is stated on
     screen rather than done in silence.

     A code worth MORE than 30% is never touched. A member should never end up
     worse off than a stranger.

   /cart.js does not expose automatic discounts, so the Club 30% cannot be
   confirmed client-side. The comparison is therefore made against what the
   shopper is actually being charged right now, which needs no such knowledge.
   ============================================================ */
(function () {
  'use strict';

  var CFG        = window.GOB_DISCOUNT_GUARD || {};
  var CLUB_PCT   = CFG.clubPct   || 30;
  var MEMBER_TAG = CFG.memberTag || 'gob_club_member';
  var ROOT       = CFG.root      || '/';
  var CURRENCY   = CFG.currency  || 'EUR';
  var COOKIE     = 'discount_code';
  var TOL        = 0.5;          /* percentage points of rounding slack */

  var COPY = {
    swapped : 'Your GOB Club [PCT]% was applied instead of [CODE] ([WAS]%) — you’re getting the better deal.',
    undo    : 'Use [CODE] instead',
    restored: '[CODE] is back on your order.',
    failed  : 'That didn’t work — [CODE] is still on your order.'
  };

  function fill(t, v) {
    return String(t).replace(/\[(\w+)\]/g, function (_, k) {
      return v[k] != null ? v[k] : '';
    });
  }

  /* ---------- member ---------- */
  function isMember() {
    var meta = document.querySelector('meta[name="customer-tags"]');
    return !!(meta && (',' + meta.content + ',').indexOf(',' + MEMBER_TAG + ',') > -1);
  }

  /* ---------- cookie ---------- */
  function cookieGet(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function cookieKill(name) {
    /* Shopify sets it on the bare host at path /. Clear that, and the dotted
       variant, so it cannot survive on a subdomain spelling. */
    var host = location.hostname;
    var bases = [
      name + '=; Max-Age=0; path=/',
      name + '=; Max-Age=0; path=/; domain=' + host,
      name + '=; Max-Age=0; path=/; domain=.' + host.replace(/^www\./, '')
    ];
    bases.forEach(function (b) { try { document.cookie = b; } catch (e) {} });
  }

  /* ---------- cart ---------- */
  function getCart() {
    return fetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function setDiscount(code) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function announce(cart) {
    ['cart:updated', 'cart:build'].forEach(function (ev) {
      try { document.dispatchEvent(new CustomEvent(ev, { detail: { cart: cart } })); } catch (e) {}
    });
  }

  function liveCodes(cart) {
    return (cart && cart.discount_codes || []).filter(function (d) { return d.applicable; });
  }
  /* What the cart is actually discounted by right now, as a percentage of list
     price. Works for a code, an automatic discount, or both, without naming any
     of them. */
  function discountPct(cart) {
    var orig = cart.original_total_price || cart.total_price || 0;
    if (!orig) { return 0; }
    return (cart.total_discount || 0) / orig * 100;
  }

  /* The shopper asked for this code back — never fight them for it again. */
  function keepKey(code) { return 'gob_dg_keep_' + String(code).toLowerCase(); }
  function isKept(code) {
    try { return sessionStorage.getItem(keepKey(code)) === '1'; } catch (e) { return false; }
  }
  function keep(code) {
    try { sessionStorage.setItem(keepKey(code), '1'); } catch (e) {}
  }

  /* ---------- the notice ---------- */
  function styles() {
    if (document.getElementById('gob-dg-css')) { return; }
    var s = document.createElement('style');
    s.id = 'gob-dg-css';
    s.textContent =
      '.gob-dg{display:flex;gap:9px;align-items:flex-start;margin:10px 0 0;padding:10px 12px;' +
        'border:1px solid #E7EAEE;border-radius:8px;background:#FFFDF7;' +
        'font-size:12.5px;line-height:1.5;color:#101123}' +
      '.gob-dg__i{flex:none;width:16px;height:16px;margin-top:1px;color:#D9971A}' +
      '.gob-dg__t{flex:1 1 auto;min-width:0}' +
      '.gob-dg__u{display:inline-block;margin-top:4px;background:none;border:0;padding:0;' +
        'font:inherit;color:#6E7183;text-decoration:underline;cursor:pointer}' +
      '.gob-dg__u:hover{color:#101123}';
    (document.head || document.documentElement).appendChild(s);
  }

  function hosts() {
    /* the drawer footer and, on /cart, the page footer */
    return Array.prototype.slice.call(
      document.querySelectorAll('#HeaderCart .cart__footer, .cart__footer')
    );
  }

  function notice(text, undoLabel, onUndo) {
    styles();
    hosts().forEach(function (host) {
      var el = host.querySelector('[data-gob-dg]');
      if (!el) {
        el = document.createElement('div');
        el.className = 'gob-dg';
        el.setAttribute('data-gob-dg', '');
        el.setAttribute('role', 'status');
        el.innerHTML =
          '<svg class="gob-dg__i" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="8.6" stroke="currentColor" stroke-width="1.7"/>' +
            '<path d="M12 7.6v5.2M12 16.2h.01" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
          '</svg><span class="gob-dg__t"></span>';
        host.insertBefore(el, host.firstChild);
      }
      var t = el.querySelector('.gob-dg__t');
      t.textContent = text;
      if (undoLabel) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gob-dg__u';
        b.textContent = undoLabel;
        b.addEventListener('click', onUndo);
        t.appendChild(document.createElement('br'));
        t.appendChild(b);
      }
    });
  }

  /* ---------- the two jobs ---------- */
  var busy = false;

  function run() {
    if (busy) { return; }
    busy = true;
    getCart().then(function (cart) {
      if (!cart) { return; }

      /* FIX 1 — the cookie outlived the code it names */
      var stored = cookieGet(COOKIE);
      if (stored) {
        var stillOn = liveCodes(cart).some(function (d) {
          return String(d.code).toLowerCase() === stored.toLowerCase();
        });
        if (!stillOn) { cookieKill(COOKIE); }
      }

      /* FIX 2 — member holding a code worth less than the Club */
      if (!isMember() || !cart.item_count) { return; }
      var codes = liveCodes(cart);
      if (!codes.length) { return; }
      var code = codes[0].code;
      if (isKept(code)) { return; }

      var was = discountPct(cart);
      if (was >= CLUB_PCT - TOL) { return; }   /* as good or better — leave it alone */

      return setDiscount('').then(function (updated) {
        if (!updated) { return; }
        cookieKill(COOKIE);
        announce(updated);
        notice(
          fill(COPY.swapped, { PCT: CLUB_PCT, CODE: code, WAS: Math.round(was) }),
          fill(COPY.undo, { CODE: code }),
          function () { undo(code); }
        );
      });
    }).catch(function () { /* offline or rate limited — leave the cart alone */ })
      .then(function () { busy = false; });
  }

  function undo(code) {
    keep(code);
    setDiscount(code).then(function (updated) {
      var ok = updated && liveCodes(updated).some(function (d) {
        return String(d.code).toLowerCase() === String(code).toLowerCase();
      });
      if (updated) { announce(updated); }
      notice(fill(ok ? COPY.restored : COPY.failed, { CODE: code }), null, null);
    }).catch(function () {
      notice(fill(COPY.failed, { CODE: code }), null, null);
    });
  }

  function boot() {
    run();
    ['cart:updated', 'cart:build', 'ajaxProduct:added', 'CartDrawer:open'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(run, 150); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
